import { useContext } from 'react'
import Align from '../../../../../types/align'
import { UgeLayersContext } from '../../../contexts/layers'
import { CaptionLayer } from '../../../types'
import { strokeWidth, ugeStrokeSizes } from '../../../types/stroke-size'
import Color from './color'
import Font from './font'
import StrokeColor from './stroke-color'
import { Options } from './style'
import TextAlign from './text-align'

type Props = {
    caption: CaptionLayer
    className?: string
    defaultFontSize?: number
}

const CaptionEditorStyleOptions = ({ caption, className, defaultFontSize }: Props) => {
    const {
        id,
        props: { textStyle },
    } = caption

    const { updateLayer } = useContext(UgeLayersContext)

    const onAlignChange = (align: Align) => {
        updateLayer(id, { textStyle: { ...textStyle, align } })
    }

    const onColorChange = (color: string) => {
        updateLayer(id, { textStyle: { ...textStyle, color } })
    }

    const onFontChange = (fontFamily: string, scale: number) => {
        const fontSize = (defaultFontSize || textStyle.fontSize) * scale
        updateLayer(id, { textStyle: { ...textStyle, fontFamily, fontSize } })
    }

    const onStrokeColorChange = (strokeColor: string) => {
        updateLayer(id, { textStyle: { ...textStyle, strokeColor } })
    }

    const onStrokeSizeChange = (index: number = 0) => {
        const size = ugeStrokeSizes[index]
        const strokeSize = strokeWidth(size)
        updateLayer(id, { textStyle: { ...textStyle, strokeSize } })
    }

    return (
        <Options className={className}>
            <Font fontFamily={textStyle.fontFamily} onChange={onFontChange} />
            <Color color={textStyle.color} icon="fill" label="Fill Color" onChange={onColorChange} />
            <StrokeColor
                color={textStyle.strokeColor}
                strokeSize={textStyle.strokeSize}
                onColorChange={onStrokeColorChange}
                onSizeChange={onStrokeSizeChange}
            />
            <TextAlign align={textStyle.align} onChange={onAlignChange} />
        </Options>
    )
}

export default CaptionEditorStyleOptions
